



import { getLink } from '../../../../utils/utils';

import author from './author';

const content = {
  rus: (
    `
    <div style="text-align: justify;">
    
      <p class="text-center bold mb-3">* * *</p>

      <p class="mb-3">
        В лаборатории уже никого не было.
      </p>
      
      <p class="mb-3">
        С порога он ещё раз бросил взгляд на термостат, где выдерживались чашки Петри с его культурами. Всё было в порядке.  
      </p>
      
      <p class="mb-3">
        Он выключил свет и запер за собой дверь.
      </p>


      <p class="text-center bold mb-3">* * *</p>

      <p class="mb-3">
        На следующее утро новые культуры были переведены на питательные субстраты. В огромном лабораторном термостате шарики питательных субстратов были подвешены к вращающейся раме, которая медленно обращалась вокруг мощной лампы в центре, чтобы обеспечить равномерное распределение тепла и света. 
      </p>
      
      <p class="mb-3">
        В шкафу термостата одновременно проводилось несколько экспериментов, однако сотрудники лаборатории не мешали друг другу и свет посторонних ламп не влиял на другие культуры. 
      </p>


      <p class="text-center bold mb-3">* * *</p>


      <p class="mb-3">
        Эксперимент был начат и записан в книге регистрации под номером 3824: «Выведение самоуничтожающейся культуры».
      </p>
      
      <p class="mb-3">
        Затем всё пошло как обычно. Нарастание плёнки биомассы, тщательное исследование проходящих в ней процессов под микроскопом и биохимическими методами (были отобраны пробы для анализов), записи в дневнике опыта.
      </p>
        
      <p class="mb-3">
        Накапливался материал для диссертации. Ещё несколько серий опытов – и близок конец! Тема многообещающая: ведь такие культуры, будучи добавлены к определённым субстратам, могут привнести в них совсем новые качества, что принесёт большую пользу народному хозяйству, возможен значительный экономический эффект.
      </p>


      <p class="text-center bold mb-3">* * *</p>


      <p class="mb-3">
        Однако никакого экономического эффекта не вышло. Вместо того, чтобы самоуничтожиться, оставив после себя окультуренный субстрат, эта культура уничтожила также и сам субстрат. На 30-ый день опыта шарик со слабым треском лопнул.
      </p>
      
      <p class="mb-3">
        В его остатках невозможно было найти следов внесённой «живой материи»; но и для хозяйственных целей эти разваливающиеся в руках слизистые комочки не годились. Первый опыт удался лишь наполовину. 
      </p>


      <p class="text-center bold mb-3">* * *</p>


      <p class="mb-3">
        Дальнейшее исследование саморазрушающихся культур привело его к новым открытиям; он защитил диссертацию, стал лауреатом нескольких научных премий. Выведенные им культуры производили множество полезных продуктов, и точно в назначенное время разлагались, исчезая бесследно.
      </p>
      
      <p class="mb-3">
        А первый, неудачный шарик назывался на языке своих обитателей «Земля», и многие миллионы лет протекли там, прежде чем её блестящая цивилизация пришла к своему концу в славной битве своих сверхдержав.
      </p>

    </div>
    `
  )
}

const itemName = {
  rus: `Опыт №3824`
}


const item = {
  itemlink: getLink(itemName.rus),
  rus: {
    itemName: itemName.rus,
    itemContent: content.rus,
    itemAuthor: author.rus
  }
}

export default item;